<template class="w-100">
    <div class="container">
        <h3>{{ title }}</h3>
    </div>
</template>

<script>
export default {
  props: {
    modelValue: { required: true },
    required: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true,
      default: " "
    }
  }
}
</script>